import { default as Footer } from './Footer';

export default Footer;
